<div class="cat-page">

  <!-- ── Page Header ── -->
  <div class="page-header">
    <div class="page-header-text">
      <p class="cat-label">{{ 'cat.products_eyebrow' | translate }}</p>
      <h2 class="cat-title">{{ cat_obj.name }}</h2>
    </div>
    <div class="cat-actions">
      <button class="cd-btn cd-btn--primary" data-bs-toggle="modal" data-bs-target="#product">
        <span class="material-symbols-outlined">add</span>
        {{ 'btn.add_product' | translate }}
      </button>
      <button class="cd-btn cd-btn--edit" data-bs-toggle="modal" data-bs-target="#category">
        <span class="material-symbols-outlined">edit</span>
        {{ 'btn.edit' | translate }}
      </button>
      <button class="cd-btn cd-btn--danger" data-bs-toggle="modal" data-bs-target="#DeleteCategory">
        <span class="material-symbols-outlined">delete</span>
        {{ 'btn.delete' | translate }}
      </button>
    </div>
  </div>

  <!-- ── Filter ── -->
  <div class="cat-filter-wrap">
    <span class="material-symbols-outlined cat-filter-icon">search</span>
    <input
      (input)="search($event)"
      type="search"
      [placeholder]="'ph.search_products' | translate"
      class="filter-input cat-search"
    />
  </div>

  <!-- ── Products Section ── -->
  <div class="cd-section">
    <div class="cd-section-header">
      <span class="material-symbols-outlined">inventory_2</span>
      <h3 class="cd-section-title">{{ 'lbl.products' | translate }}</h3>
    </div>

    <div class="cd-products-grid" *ngIf="showProduct">
      <div
        class="cd-product-card"
        *ngFor="let item of product_arr"
        (click)="productDetails(item.id)"
      >
        <div class="cd-product-img-wrap">
          <img class="cd-product-img" [src]="item.images[0].image_url" [alt]="item.name" />
        </div>
        <div class="cd-product-info">
          <p class="cd-product-name">{{ item.name }}</p>
        </div>
      </div>
    </div>

    <div class="cd-empty" *ngIf="!showProduct">
      <div class="cd-empty-icon">
        <span class="material-symbols-outlined">inventory_2</span>
      </div>
      <h3>{{ 'empty.products' | translate }}</h3>
      <p>{{ 'empty.products_sub' | translate }}</p>
    </div>
  </div>

</div>

<!-- ══════════════════════════════════════
     Add Product Modal
════════════════════════════════════════ -->
<div class="modal fade" id="product" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content cd-modal-content">

      <div class="cd-modal-header cd-modal-header--row">
        <div>
          <p class="cd-modal-eyebrow">{{ (showUpload ? 'prod.step2' : 'prod.step1') | translate }}</p>
          <h5 class="cd-modal-title">{{ (showUpload ? 'prod.media' : 'prod.details') | translate }}</h5>
        </div>
        <button type="button" class="cd-modal-close" data-bs-dismiss="modal" (click)="resetProductModal()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="cd-steps">
        <div class="cd-step" [class.cd-step--active]="!showUpload" [class.cd-step--done]="showUpload">
          <span class="cd-step-dot"></span>
          <span class="cd-step-label">{{ 'prod.step_details' | translate }}</span>
        </div>
        <div class="cd-step-line"></div>
        <div class="cd-step" [class.cd-step--active]="showUpload">
          <span class="cd-step-dot"></span>
          <span class="cd-step-label">{{ 'prod.step_media' | translate }}</span>
        </div>
      </div>

      <div class="cd-modal-body">

        <form [formGroup]="productForm" *ngIf="!showUpload">
          <div class="cd-field-row">
            <div class="cd-field-group">
              <label class="cd-field-label">{{ 'lbl.name' | translate }} *</label>
              <input formControlName="name" type="text" class="cd-input" [placeholder]="'ph.product_name' | translate" />
              <span class="cd-field-error"
                *ngIf="(productForm.controls['name'].touched || formStatus) && productForm.controls['name'].errors?.['required']">
                {{ 'err.required' | translate }}
              </span>
            </div>
            <div class="cd-field-group">
              <label class="cd-field-label">{{ 'prod.arabic_name' | translate }}</label>
              <input formControlName="name_ar" type="text" class="cd-input" placeholder="اسم المنتج" dir="rtl" />
            </div>
          </div>

          <div class="cd-field-row">
            <div class="cd-field-group">
              <label class="cd-field-label">{{ 'lbl.price' | translate }} *</label>
              <input formControlName="price" type="number" min="0" step="0.01" class="cd-input" [placeholder]="'ph.price' | translate" />
              <span class="cd-field-error"
                *ngIf="(productForm.controls['price'].touched || formStatus) && productForm.controls['price'].errors?.['required']">
                {{ 'err.required' | translate }}
              </span>
            </div>
            <div class="cd-field-group">
              <label class="cd-field-label">{{ 'lbl.quantity' | translate }} *</label>
              <input formControlName="quantity" type="number" min="0" class="cd-input" [placeholder]="'ph.quantity' | translate" />
              <span class="cd-field-error"
                *ngIf="(productForm.controls['quantity'].touched || formStatus) && productForm.controls['quantity'].errors?.['required']">
                {{ 'err.required' | translate }}
              </span>
            </div>
          </div>

          <div class="cd-field-group">
            <label class="cd-field-label">{{ 'lbl.description' | translate }} *</label>
            <textarea formControlName="description" class="cd-input cd-textarea" [placeholder]="'ph.description' | translate"></textarea>
            <span class="cd-field-error"
              *ngIf="(productForm.controls['description'].touched || formStatus) && productForm.controls['description'].errors?.['required']">
              {{ 'err.required' | translate }}
            </span>
          </div>

          <div class="cd-field-group">
            <label class="cd-field-label">{{ 'prod.arabic_desc' | translate }}</label>
            <textarea formControlName="description_ar" class="cd-input cd-textarea" placeholder="وصف المنتج..." dir="rtl"></textarea>
          </div>
        </form>

        <div *ngIf="showUpload" class="cd-upload-section">
          <div class="cd-upload-note">
            <span class="material-symbols-outlined">check_circle</span>
            {{ 'prod.saved_msg' | translate }}
          </div>
          <div class="cd-field-group">
            <label class="cd-field-label">{{ 'prod.main_images' | translate }}</label>
            <input multiple (change)="uploadFile($event, 'main')" type="file" accept="image/*" class="cd-input cd-file-input" />
          </div>
          <div class="cd-field-group">
            <label class="cd-field-label">{{ 'prod.product_video' | translate }}</label>
            <input multiple (change)="uploadFile($event, 'video')" type="file" accept="video/*" class="cd-input cd-file-input" />
          </div>
          <div class="cd-field-group">
            <label class="cd-field-label">{{ 'prod.screenshots' | translate }}</label>
            <input multiple (change)="uploadFile($event, 'screenshot')" type="file" accept="image/*" class="cd-input cd-file-input" />
          </div>
        </div>

      </div>

      <div class="cd-modal-footer">
        <button type="button" class="cd-btn cd-btn--ghost" data-bs-dismiss="modal" (click)="resetProductModal()">
          {{ 'btn.cancel' | translate }}
        </button>
        <button *ngIf="!showUpload" (click)="addProduct()" type="button" class="cd-btn cd-btn--primary">
          {{ 'btn.continue' | translate }}
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>
        <button *ngIf="showUpload" data-bs-dismiss="modal" (click)="addProductImage()" type="button" class="cd-btn cd-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_product' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ══════════════════════════════════════
     Edit Category Modal
════════════════════════════════════════ -->
<div class="modal fade" id="category" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content cd-modal-content">
      <div class="cd-modal-header cd-modal-header--row">
        <div>
          <p class="cd-modal-eyebrow">{{ 'cat.products_eyebrow' | translate }}</p>
          <h5 class="cd-modal-title">{{ 'cat.edit_title' | translate }}</h5>
        </div>
        <button type="button" class="cd-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="cd-modal-body">
        <div class="cd-field-group">
          <label class="cd-field-label">{{ 'lbl.name' | translate }}</label>
          <input [(ngModel)]="cat_name" type="text" class="cd-input" [placeholder]="'ph.category_name' | translate" />
        </div>
        <div class="cd-field-group">
          <label class="cd-field-label">{{ 'lbl.image' | translate }}</label>
          <input (change)="uploadFileCat($event)" type="file" class="cd-input cd-file-input" />
        </div>
      </div>
      <div class="cd-modal-footer">
        <button type="button" class="cd-btn cd-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="editCat()" type="button" data-bs-dismiss="modal" class="cd-btn cd-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_changes' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════
     Delete Category Modal
════════════════════════════════════════ -->
<div class="modal fade" id="DeleteCategory" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content cd-modal-content">
      <div class="cd-modal-header cd-modal-header--centered">
        <div class="cd-modal-icon cd-modal-icon--danger">
          <span class="material-symbols-outlined">delete_forever</span>
        </div>
        <h5 class="cd-modal-title">{{ 'confirm.delete_category' | translate }}</h5>
        <p class="cd-modal-subtitle">
          {{ 'confirm.are_you_sure_delete' | translate }} <strong>{{ cat_obj.name }}</strong>?
          {{ 'confirm.cannot_undo' | translate }}
        </p>
      </div>
      <div class="cd-modal-footer cd-modal-footer--centered">
        <button type="button" class="cd-btn cd-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="deleteCategory()" type="button" data-bs-dismiss="modal" class="cd-btn cd-btn--danger">
          <span class="material-symbols-outlined">delete</span>
          {{ 'btn.delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
